$(document).ready(() => {
  // ga4点击事件
  $('body').on( 'click', '[data-ga4_content_type][data-ga4_click]', function () {
    handleGa4Event(this, 'click');
  });

  // ga4输入事件
  $('body').on('blur keypress', '[data-ga4_content_type][data-ga4_input]', function (e) {
    if (e.type === 'keypress' && e.which != 13) {
      return;
    }
    handleGa4Event(this, 'input');
  });

  //统一处ga4事件
  function handleGa4Event(elem, event_type) {
    if (elem) {
      const { ga4_content_type, ga4_series_name, ga4_extra_data, ga4_product_id, ga4_section_name } = $(elem).data();
      const params = {
        content_type: ga4_content_type, // 事件名称
        section_id: ga4_series_name, //
        section_name: ga4_section_name,
        series_name: ga4_series_name, // 二级命名
        extra_data: ga4_extra_data, // 额外参数
        productID: ga4_product_id, // 产品id
      };
      if(event_type !== 'click'){
        params.extra_data = $(elem).val();
      }
      // GAReporter.report(params);
      sendGa4Event(params);
    }
  }


  // ins插件
  $('.social-widget-wrapper').on('click', function (e) {
    const params = {
      content_type: 'home_ins', // 事件名称
      section_id: 'home_ins', //
      section_name: 'ins',
      series_name: 'home_ins', // 二级命名
      extra_data: '', // 额外参数
      productID: '', // 产品id
    };
    // GAReporter.report(params);
    sendGa4Event(params);
  });


  //   jdgm 插件 start
  // 评论图片
  $('body').on('click', '.jdgm-gallery-wrapper .jdgm-gallery .jdgm-gallery__thumbnail-link', function () {
      // 获取当前画廊内的索引
      const $gallery = $(this).closest('.jdgm-gallery');
      const galleryIndex = $gallery.find('.jdgm-gallery__thumbnail-link').index(this);

      const params = {
        content_type: 'product_comment',
        section_id: 'product_comment',
        section_name: 'product_comment',
        series_name: `product_comment_picture-${galleryIndex}`,
      };
      // GAReporter.report(params);
      sendGa4Event(params);
    },
  );
  // 评论大图
  $('body').on('click', '.jm-mfp-carousel .jdgm-gallery .jdgm-gallery__thumbnail-link', function () {
      // 获取当前画廊内的索引
      const $gallery = $(this).closest('.jdgm-gallery');
      const galleryIndex = $gallery.find('.jdgm-gallery__thumbnail-link').index(this);

      const params = {
        content_type: 'product_comment',
        section_id: 'product_comment',
        section_name: 'product_comment',
        series_name: `product_comment_big_picture-${galleryIndex}`,
      };
      // GAReporter.report(params);
      sendGa4Event(params);
    },
  );
  // 评论大图
  $('body').on('click', '.jdgm-rev-widg__body .jdgm-rev__pics', function () {
    const params = {
      content_type: 'product_comment',
      section_id: 'product_comment',
      section_name: 'product_comment',
      series_name: `product_comment_detail_picture`,
    };
    // GAReporter.report(params);
    sendGa4Event(params);
  });
  //   jdgm 插件 end


  // 详情轮播图切换
  $('.js-section__product-single media-gallery media-carousel').on(
    'on:media-carousel:slide-change',
    function (e) {
      const index = e.target.index;
      const productId = $(this).parents('product-single').data('productId');
      const params = {
        content_type: 'product_slide', // 事件名称
        section_id: 'product', //
        section_name: 'product',
        series_name: 'product_slide_scroll', // 二级命名
        extra_data: index, // 额外参数
        productID: productId, // 产品id
      };
      // GAReporter.report(params);
      sendGa4Event(params);
    },
  );
  
  //发送ga4事件
  function sendGa4Event(params) {
    setTimeout(() =>{
      window.gtag && gtag('event', 'click_manual', params);
    });
  }
});
